module.exports = __webpack_public_path__ + "src/assets/img/mft_logo__black.d7abbbc8.svg";